import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Topbar.css';

const Topbar = ({ pathname, handleNewPackage, addOptionBuilder, handleDisplayPLChart }) => {
  const navigate = useNavigate();
  const isBuilderRoute = pathname?.startsWith('/builder');

  return (
    <div className="topbar">
      <div>
        <button onClick={() => navigate('/')} className="topbar-button">
          Home
        </button>
        <button onClick={() => navigate('/tutorials')} className="topbar-button">
          Tutorials & Videos
        </button>
        <button onClick={() => navigate('/account')} className="topbar-button">
          Account
        </button>
      </div>
      <div>
        {pathname === '/' && (
          <button onClick={handleNewPackage} className="topbar-button">
            <span role="img" aria-label="create">➕</span> Create Option Package
          </button>
        )}
        {isBuilderRoute && (
          <>
            <button onClick={addOptionBuilder} className="topbar-button">
              <span role="img" aria-label="create">➕</span> Add Option Combo
            </button>
            <button onClick={handleDisplayPLChart} className="topbar-button">
              <span role="img" aria-label="graph">📈</span> Draw Profit/Loss Graph
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Topbar;
